"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listSlotTypesApiResponseSchema = exports.assistantSlotTypeItemSchema = exports.assistantSlotTypeTimeRangeSchema = void 0;
const zod_1 = require("zod");
const api_1 = require("../global/api");
const paginate_list_api_response_schema_1 = require("../global/paginate-list-api-response.schema");
const enums_1 = require("./enums");
const timeStringSchema = zod_1.z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
exports.assistantSlotTypeTimeRangeSchema = zod_1.z.object({
    startTime: timeStringSchema,
    endTime: timeStringSchema,
});
exports.assistantSlotTypeItemSchema = zod_1.z.object({
    id: zod_1.z.string().uuid(),
    type: (0, api_1.apiEntityTypeSchema)('assistant-slot-types'),
    attributes: zod_1.z.object({
        label: zod_1.z.string(),
        workedMinutes: zod_1.z.number().int(),
        timeRanges: zod_1.z.array(exports.assistantSlotTypeTimeRangeSchema),
        /**
         * When false, shifts of this type are worked time but are not counted as
         * the assistant covering a booked office slot (e.g. training / "Formation").
         */
        countsAsOfficePresence: zod_1.z.boolean(),
        scope: enums_1.slotTypeScopeSchema,
        officeId: zod_1.z.string().uuid().nullable(),
    }),
});
exports.listSlotTypesApiResponseSchema = (0, paginate_list_api_response_schema_1.paginteListApiResponseSchema)(exports.assistantSlotTypeItemSchema);
